import EventClass from "common/utils/ui/event-class";
import { track } from "jiffy-analytics";

// eslint-disable-next-line import/prefer-default-export
export class ProductsFilterModalWrapperVisibilityClass extends EventClass {
  #eventSelector;

  #modalSelector;

  #isOpenModal = false;

  #hiddenClassName = "hidden";

  #lockedDocumentScrollClassName = "locked-mobile";

  #chatSelector = "#tidio-chat, #google-merchantwidget-iframe-wrapper";

  constructor(props) {
    super(props);

    this.#eventSelector = props.eventSelector;
    this.#modalSelector = props.modalSelector;
    this.initMobileAppTriggers();
  }

  get #$modalWrapper() {
    return document.querySelector(this.#modalSelector);
  }

  get #$chats() {
    return document.querySelectorAll(this.#chatSelector);
  }

  #setToggleFocus() {
    const $toggle = document.querySelector(this.#eventSelector);
    $toggle?.focus();
  }

  toggleModal() {
    if (this.#isOpenModal) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }

  event(event, target) {
    super.event(event, target);
    this.toggleModal();
  }

  initMobileAppTriggers() {
    window.toggleMobileAppFilters = () => {
      // Trigger the full event flow to ensure filters are loaded
      // Pass null for event and target since they're not needed from mobile app trigger
      this.event(null, null);
    };
  }

  closeModal() {
    track("filter_modal_closed");
    this.#$modalWrapper?.classList.add(this.#hiddenClassName);
    this.#$chats.forEach($chat => $chat.classList.remove(this.#hiddenClassName));
    document.documentElement.classList.remove(this.#lockedDocumentScrollClassName);
    this.#isOpenModal = false;
  }

  openModal() {
    track("filter_modal_opened");
    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
    document.documentElement.classList.add(this.#lockedDocumentScrollClassName);
    this.#$modalWrapper?.classList.remove(this.#hiddenClassName);
    this.#$chats.forEach($chat => $chat.classList.add(this.#hiddenClassName));
    this.#setToggleFocus();
    this.#isOpenModal = true;
  }
}
